export default __webpack_public_path__ + "static/media/skateboard-boy.325f81ad.png";